import React from "react";

function Footer() {
    return (
        <div className="footer" style={{paddingTop: "50px"}}>
            <footer className="py-3 bg-dark fixed-bottom">
            </footer>
        </div>
    );
}

export default Footer;
